var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-union-component"},[(_vm.logoUnionImg)?_c('van-image',{staticClass:"logo-union-img",attrs:{"lazy-load":"","src":_vm.logoUnionImg}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }